import type { ProductInfoDialogProps } from '@ori/product-info-dialog-lib';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationKeys } from '../models';

export const useTranslations = (): ProductInfoDialogProps['translations'] => {
  const [translate] = useTranslation();

  return useMemo(
    () => ({
      buy: translate(TranslationKeys.buy),
      choose: translate(TranslationKeys.choose),
      lowestPrice: translate(TranslationKeys.lowestPriceText),
      mrpStatement: translate(TranslationKeys.inclusiveOfAllTaxes),
      newEdition: translate(TranslationKeys.newEdition),
      newEditionAvailable: translate(TranslationKeys.newEditionAvailable),
      replace: translate(TranslationKeys.replace),
      replaceWith: translate(TranslationKeys.replaceWith),
      reserve: translate(TranslationKeys.reserve),
      save: translate(TranslationKeys.save),
    }),
    [translate],
  );
};
